import { render } from "./RecoveryPlan.vue?vue&type=template&id=046123de&scoped=true"
import script from "./RecoveryPlan.vue?vue&type=script&lang=js"
export * from "./RecoveryPlan.vue?vue&type=script&lang=js"

import "./RecoveryPlan.vue?vue&type=style&index=0&id=046123de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046123de"]])

export default __exports__